module.exports = __webpack_public_path__ + "images/frontpage_mobile@3x.jpg?93f45c24";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_mobile@3x.jpg
// module id = 656
// module chunks = 7